import { Link } from "react-router-dom";
import type { MergedAccountView } from "@sales-ops-amplify/shared";
import { useClientPagination } from "@/hooks/usePagination";
import { PaginationBar } from "@/components/pagination-bar";

export function CompanyOpportunitiesTab({
  merged,
}: {
  merged: MergedAccountView;
}) {
  const opportunities = merged.opportunities ?? [];
  const pagination = useClientPagination(opportunities);

  if (opportunities.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-border px-4 py-12 text-center">
        <p className="text-sm font-medium">No opportunities</p>
        <p className="mt-1 text-xs text-muted-foreground">
          Deals linked to this company will appear here.
        </p>
        <Link
          to="/deals"
          className="mt-3 inline-block text-sm text-brand hover:underline"
        >
          Browse deals
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="space-y-2">
        {pagination.pageItems.map((job) => (
          <Link
            key={job.id}
            to={`/deals/${job.opportunityId ?? job.id}`}
            className="block rounded-md border border-border bg-card px-3 py-2.5 text-sm hover:bg-muted/10"
          >
            <span className="font-medium text-foreground">
              {job.dealName || job.opportunityId || job.id}
            </span>
            <span className="ml-2 text-xs text-muted-foreground">
              {job.stage ?? job.status}
            </span>
          </Link>
        ))}
      </div>
      <PaginationBar
        page={pagination.page}
        pageSize={pagination.pageSize}
        totalItems={opportunities.length}
        totalPages={pagination.totalPages}
        showingFrom={pagination.showingFrom}
        showingTo={pagination.showingTo}
        onPageChange={pagination.setPage}
        onPageSizeChange={pagination.setPageSize}
      />
    </div>
  );
}
